import React from 'react';
import { AppContext } from '../AppContext';

const Test = (props) => {
    const app = React.useContext(AppContext);

    return (
        <div id="Settings1" className="page1">
            <div className="wrapper">
                <div className="pageTitle">
                    <a className="backButton" href="#"></a>
                    <h1>Test</h1>
                </div>
                <div>
                    <button onClick={() => { app.showEnjoyGame() }}>
                        Show Enjoy Dialog
                    </button>
                </div>
                <div>
                    <button onClick={() => { app.showShare() }}>
                        Show Share
                    </button>
                </div>
                <div>  <button onClick={() => { app.showNotification("Test notification") }}>
                    showNotification
                </button>
                </div>
                <div>
                    <button onClick={() => {
                        app.showNotification({ title: "Test", type: "Achievement", image: "https://picsum.photos/200/300", points: 25, description: "Test description" });
                    }}>
                        showNotification Achievement
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        app.navigate("Game/Test/CrazyNinja");
                    }}>
                        Test GameUI Mode - Test vs Crazy Ninja
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        fetch("assets/Decks/PixaromaDeck_SpriteSheet.png").then((response) => {
                            console.log(response);
                        }).catch((error) => {
                            console.log(error,response);
                        });
                    }}>
                        fetch("assets/Decks/PixaromaDeck_SpriteSheet.png")
                    </button>
            </div>

        </div>
        </div >
    )
};

export default Test;

